import { ThemeColors } from '../Theme';
import { Slot } from './Slot';

import { Global } from './Global'

export class Availability extends Slot {


    static createNew(start, end, resource) {
        
        const availability = new Availability();
        availability.type = "Availability";
        availability.title = "Expanded Availability";
        
        // call superclass method        
        availability.newSlot("av", start, end, [resource.id]);

        availability.color = ThemeColors.availabilityColor;
        return availability;
    }

    copy() {
        const copy = new Availability();
        super.copy(copy);
        return copy;
    }

    hasPatrons() {
        return false;
    }

    canEdit(resources) {

        if (Global.isResourceManager())      // resource managers can always edit Availability
            return true;
        
        const service = this.getService(resources);
        if (!service) {
            console.error("Availability " + this.id + " does not have a Service, which is not allowed");
            return false;
        }

        if (service.owner === Global.user.id) {        // owners of services can always edit their bookings (and there can only be one)
            return true;
        }
        
        return false;
    }

}